import { CreateApi } from "../../CreateApi";
import { Methods, Urls } from "../../../common/Utils/ApiConstants";
const pendingApprovalscollection = CreateApi.injectEndpoints({
  endpoints: (builder) => ({
    getPendingAprrovalsData: builder.query({
      query: (body) => {
        const { pageNo, moduleType } = body;
        return {
          url: Urls.getPendingApprovalList,
          method: Methods.get,
          params: { pageNo, moduleType },
        };
      },
      transformResponse: (response) => {
        return response.data;
      },
    }),
  }),
});
export const { useLazyGetPendingAprrovalsDataQuery } =
  pendingApprovalscollection;
